module.exports = __webpack_public_path__ + "img/logo.baee6503.png";